import { Controller } from '@hotwired/stimulus'

// 2fa form support for:
// - pasting 6 digits -> auto submits the form
// - showing an alert if more than 6 digits are pasted or typed
export default class extends Controller {
    static targets = ['code', 'submit', 'characterAlert']

    connect() {
        this.validateCode()
    }

    validateCode() {
        const { value } = this.codeTarget

        if (value <= 6) {
            this.characterAlertTarget.classList.add('d-none')
        }

        if (value.length === 6) {
            return true
        }
        if (value.length > 6) {
            this.codeTarget.value = value.slice(0, 6)
            this.characterAlertTarget.classList.remove('d-none')
            return false
        }
        return false
    }

    handlePaste() {
        setTimeout(() => {
            if (this.validateCode()) {
                this.disableSubmit()
                this.submitForm()
            }
        }, 100)
    }

    handleKeyup() {
        this.validateCode()
    }

    handleSubmit(event) {
        event.preventDefault()
        if (this.validateCode()) {
            this.disableSubmit()
            this.submitForm()
        }
    }

    disableSubmit() {
        this.submitTarget.value = 'Sending code...'
        this.submitTarget.disabled = true
    }

    submitForm() {
        setTimeout(() => {
            this.element.requestSubmit()
        }, 100)
    }
}
